import { useCallback, useEffect, useState } from "react";
import { IoMdAddCircle } from "react-icons/io";
import { Header, ScrollProps } from "../../components/Header";
import { Container } from "./styles";
import { GoToTop } from "../../GoToTop";
import { Footer } from "../../components/Footer";
import { useAuth } from "../../context/auth";
import {
  CardProposal,
  IKanbanProposalItem,
} from "../../components/CardProposal";
import ModalProposta from "../../components/Proposta/ModalProposta";
import { HUB_STATUS_COLUMNS } from "../../components/Proposta/utils/propostaConstants";

export function Kanban() {
  const { user, api } = useAuth();
  const [scrollTop, setScrollTop] = useState<ScrollProps>({
    y: 0,
    lastY: 0,
  } as ScrollProps);
  const [show, setShow] = useState(false);
  const [search, setSearch] = useState("");
  const [kanbanData, setKanbanData] = useState<IKanbanProposalItem[]>([]);
  const [totals, setTotals] = useState<
    Record<number, { count: number; valor: number }>
  >({});
  const [loading, setLoading] = useState(true);
  const [createOpen, setCreateOpen] = useState(false);

  const loadKanbanData = useCallback(async () => {
    if (!user?.id_corretor) return;
    setLoading(true);
    try {
      // Sem query: a API já defaulta portal=HUB (is_ppm IS NULL).
      // Mesmo path que funcionava antes no portal.
      const res = await api.get(`/sin/proposta/${user.id_corretor}`);
      const data = (res.data || []) as IKanbanProposalItem[];
      setKanbanData(data);

      const nextTotals: Record<number, { count: number; valor: number }> = {};
      HUB_STATUS_COLUMNS.forEach((col) => {
        nextTotals[col.statusCode] = { count: 0, valor: 0 };
      });

      data.forEach((v) => {
        if (!nextTotals[v.status]) {
          nextTotals[v.status] = { count: 0, valor: 0 };
        }
        nextTotals[v.status].count += 1;
        nextTotals[v.status].valor += Number(v.valor) || 0;
      });

      setTotals(nextTotals);
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  }, [user?.id_corretor, api]);

  const handleScroll = (event: React.UIEvent<HTMLDivElement>) => {
    const scrollTopValue = event.currentTarget.scrollTop;
    setScrollTop((prevState) => ({
      y: scrollTopValue,
      lastY: prevState.y,
    }));
  };

  useEffect(() => {
    loadKanbanData();
  }, [loadKanbanData]);

  return (
    <>
      <ModalProposta
        open={createOpen}
        onClose={() => setCreateOpen(false)}
        onSuccess={loadKanbanData}
        mode="create"
      />

      <Container onScroll={handleScroll}>
        <Header
          scroll={scrollTop}
          show={show}
          setShow={setShow}
          search={search}
          setSearch={setSearch}
        />

        <div className="content_wrapper">
          <div className="page_title_wrapper">
            <h2 className="page_title">Propostas</h2>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                marginLeft: "10px",
                width: "fit-content",
              }}
            >
              <button
                type="button"
                className="button_new_proposal"
                onClick={() => setCreateOpen(true)}
                style={{
                  width: "200px",
                  height: "40px",
                  color: "#fff",
                  background: "#0E2244",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "3px",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              >
                Nova Proposta
                <IoMdAddCircle />
              </button>
            </div>
          </div>

          <div id="kanban_wrapper">
            <div id="div_kanban">
              {HUB_STATUS_COLUMNS.map((value) => {
                const columnTotal = totals[value.statusCode] || {
                  count: 0,
                  valor: 0,
                };
                return (
                  <div className="div_kanban_collum" key={value.statusCode}>
                    <h3 style={{ background: value.color }}>
                      <span style={{ fontSize: "16px" }}>
                        {!loading && (
                          <span style={{ fontSize: "16px" }}>
                            {columnTotal.count}
                          </span>
                        )}
                        &nbsp;{value.descricao}
                      </span>
                      <div>
                        {!loading && (
                          <span style={{ fontSize: "16px" }}>
                            {columnTotal.valor.toLocaleString("pt-br", {
                              minimumFractionDigits: 2,
                            })}
                          </span>
                        )}
                      </div>
                    </h3>

                    <ul className="ul_kanban_collum">
                      {loading ? (
                        <div className="loading description" />
                      ) : (
                        kanbanData
                          .filter((val) => val.status === value.statusCode)
                          .map((val) => (
                            <CardProposal
                              key={val.id}
                              card={val}
                              color={value.color}
                              columnLabel={value.descricao}
                              onRefresh={loadKanbanData}
                            />
                          ))
                      )}
                    </ul>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        <GoToTop />
        <Footer />
      </Container>
    </>
  );
}
